export default __webpack_public_path__ + "static/media/Customer_due_digilence.a822549b.png";